#import "../NoteFields.graphql"

mutation createCaseNote($caseRecordId: ID!, $content: String!) {
  createCaseNote(input: { caseRecordId: $caseRecordId, content: $content }) {
    caseNote {
      ...NoteFields
    }
  }
}
